<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          Edit Document Tracker</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer
      ref="documentRules"
      tag="form"
    >
      <b-form>
        <app-timeline>
          <app-timeline-item class="pb-1">
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Parent Details</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <dl class="row">
                  <dt class="col-sm-12 dt-text">
                    Parent Type
                  </dt>
                  <dd class="col-sm-12">
                    <span
                      class="form-control h-auto"
                      v-text="addDocument.parent_type"
                    />
                  </dd>
                </dl>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <dl class="row">
                  <dt class="col-sm-12 dt-text">
                    Parent
                  </dt>
                  <dd class="col-sm-12">
                    <span
                      class="form-control h-auto"
                      v-text="addDocument.parent"
                    />
                  </dd>
                </dl>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="info"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Document Details</h6>
            </div>
            <b-modal
              ref="add_issuer"
              cancel-variant="outline-secondary"
              ok-title="Add"
              cancel-title="Close"
              centered
              title="Add Issuer"
              :no-close-on-backdrop="true"
              @hide="closingIssuerPopup"
            >
              <validation-observer
                ref="newIssuer"
                tag="form"
              >
                <b-form>
                  <b-form-group>
                    <label>Issuer</label>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Issuer"
                      rules="required"
                    >
                      <b-form-input
                        id="new-issuer"
                        v-model="addIssuerRequest.issuer"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-form>
              </validation-observer>
              <template #modal-footer>
                <div class="d-flex justify-content-end w-100">
                  <div />
                  <b-button
                    variant="primary"
                    class="ml-1 px-1"
                    @click="submitIsssuer"
                  >
                    Add
                  </b-button>
                </div>
              </template>
            </b-modal>

            <div class="repeat-border">
              <div
                class="d-flex"
              >
                <div class="left w-100">
                  <b-row>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                    >

                      <dl class="row">
                        <dt class="col-sm-12 dt-text">
                          Document Type
                        </dt>
                        <dd class="col-sm-12">
                          <span
                            class="form-control h-auto"
                            v-text="addDocument.document_type"
                          />
                        </dd>
                      </dl>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <dl class="row">
                        <dt class="col-sm-12 dt-text">
                          Document Name
                        </dt>
                        <dd class="col-sm-12">
                          <span
                            class="form-control h-auto"
                            v-text="addDocument.document_name"
                          />
                        </dd>
                      </dl>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <b-form-group>
                        <label>Issuer</label>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Issuer"
                          rules="required"
                        >
                          <div class="d-flex">
                            <div class="left w-100">
                              <v-select
                                v-model="addDocument.issuer_id"
                                :options="issuers"
                                :reduce="item => item.id"
                                :clearable="false"
                                placeholder="Select"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0]"
                              />
                            </div>
                            <div
                              v-show="addDocument.document_name_id !== null"
                              class="right ml-50"
                            >
                              <b-button
                                variant="outline-primary"
                                class="px-1"
                                @click="showIssuer()"
                              >
                                <feather-icon icon="PlusIcon" />
                              </b-button>
                            </div>
                          </div>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                      class="mt-2"
                    >
                      <b-form-checkbox
                        v-model="addDocument.no_expire"
                        @change="checkChanged()"
                      >
                        No Expire
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      v-show="!addDocument.no_expire"
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <b-form-group>
                        <label>Exp Date</label>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Exp Date"
                          :rules="addDocument.no_expire ? '' : 'required'"
                        >
                          <flat-pickr
                            v-model="exp_date"
                            class="form-control"
                            :config="exp_date_config"
                            placeholder="MM-DD-YYYY"
                          />
                          <small
                            class="text-danger"
                            v-text="errors[0]"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      v-show="!addDocument.no_expire"
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <b-form-group>
                        <label>Reminder</label>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Reminder"
                          :rules="addDocument.no_expire ? '' : 'required'"
                        >
                          <v-select
                            v-model="addDocument.reminder_id"
                            :options="reminders"
                            :reduce="item => item.id"
                            :clearable="false"
                            placeholder="Select"
                          />
                          <small
                            class="text-danger"
                            v-text="errors[0]"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <b-form-group>
                        <label>Version</label>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Version"
                          rules="required"
                        >
                          <v-select
                            v-model="addDocument.version_id"
                            :options="versions"
                            :reduce="item => item.id"
                            :clearable="false"
                            placeholder="Select"
                          />
                          <small
                            class="text-danger"
                            v-text="errors[0]"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <dl class="row">
                        <dt class="col-sm-12 dt-text">
                          Previous Document
                        </dt>
                        <dd class="col-sm-12">
                          <b-link
                            :href="addDocument.document_path"
                            :title="addDocument.file_name"
                            target="_blank"
                          >
                            <b-badge
                              variant="primary"
                              class="mr-1 mb-50"
                            >
                              <span>{{ addDocument.file_name }}</span>
                            </b-badge>
                          </b-link>
                        </dd>
                      </dl>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <b-form-group>
                        <label>Document</label>
                        <input
                          ref="documentFileInput"
                          type="file"
                          placeholder="Choose a file or drop it here..."
                          class="form-control text-left"
                          @change="attahamentFileSelected"
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </app-timeline-item>

          <app-timeline-item
            variant="success"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Last Sent Dates</h6>
            </div>
            <b-row class="mt-1">
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-badge
                  v-for="(last_sent_date, index) in addDocument.last_sent_dates"
                  :key="index"
                  variant="primary"
                  class="mr-1 mb-50"
                >
                  <span
                    v-text="last_sent_date"
                  />
                </b-badge>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="success"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Previous Versions</h6>
            </div>
            <b-row class="mt-1">
              <b-col cols="12">
                <div class="table-responsive-sm">
                  <table class="table b-table table-th-pd table-td-pd">
                    <thead>
                      <tr>
                        <th>Version</th>
                        <th>Upload Date</th>
                        <th>Exp Date</th>
                        <th>Uploaded By</th>
                        <th>Issuer</th>
                        <th>Reminder</th>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(priviousVersion, index) in addDocument.previous_versions"
                        :key="index"
                      >
                        <td>{{ priviousVersion.version }}</td>
                        <td>{{ priviousVersion.uploaded_date }}</td>
                        <td>{{ priviousVersion.exp_date }}</td>
                        <td>{{ priviousVersion.uploaded_by }}</td>
                        <td>{{ priviousVersion.issuer }}</td>
                        <td>{{ priviousVersion.reminder }}</td>
                        <td>
                          <b-link
                            target="_blank"
                            :href="priviousVersion.document_path"
                          >
                            <b-badge
                              variant="primary"
                              class="mr-1 mb-50"
                            >
                              <span>{{ priviousVersion.document_name }}</span>
                            </b-badge>
                          </b-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="warning"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Notes</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Notes</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Notes"
                  >
                    <b-form-textarea
                      id="note"
                      v-model="addDocument.notes"
                      rows="2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>
        </app-timeline>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              @click="submitForm"
            >
              Update Document Tracker
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
} from '@validations'
import {
  BCard, BRow, BCol, BModal, VBModal, BForm, BFormGroup, BFormInput, BButton, BFormTextarea, BFormCheckbox, BLink, BBadge,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import Constants from '@/js/constant'
import LIST from '@/js/lists'
import ParentDocumentType from '@/js/parentDocument'

export default {
  name: 'DocumentTrackerEdit',
  components: {
    BCard,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    BRow,
    BCol,
    BForm,
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BLink,
    vSelect,
    flatPickr,
    // currency,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      required,
      addIssuerRequest: {
        issuer: '',
        addDocumentNameRequest: null,
      },
      addDocument: {
        parent_type_id: null,
        parent_id: null,
        notes: null,
        documents: null,
      },
      exp_date_config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'm-d-Y',
        altInput: true,
        dateFormat: 'm-d-Y',
        minDate: null,
        maxDate: null,
      },
      issuerIndex: null,
      exp_date: null,
      issuers: [],
      reminders: [],
      versions: [],
    }
  },
  watch: {
    '$store.state.lists.commonLists': {
      immediate: true,
      handler() {
        LIST.getDocumentReminders(this)
        LIST.getDocumentVersions(this)
        LIST.getDocumentIssuersByDocumentNameTypeId(this, this.addDocument.document_name_id)
      },
    },
  },
  created() {
    LIST.getDocumentReminders(this)
    LIST.getDocumentVersions(this)
    ParentDocumentType.getDocumentById(this, this.$route.params.id)
  },
  methods: {
    submitForm() {
      this.$refs.documentRules.validate().then(result => {
        if (result) {
          if (this.exp_date !== null) {
            this.addDocument.exp_date = Constants.getEprmMonthDateFromString(this.exp_date)
          }
          ParentDocumentType.updateDocument(this, this.$route.params.id, this.addDocument)
        }
      })
    },
    removeNewDocument(index) {
      this.documents.splice(index, 1)
    },
    showIssuer() {
      this.addIssuerRequest.document_name_type_id = this.addDocument.document_name_id
      this.$refs.add_issuer.show()
    },
    submitIsssuer() {
      this.$refs.newIssuer.validate().then(result => {
        if (result) {
          this.showLoading = true
          ParentDocumentType.addIssuer(this, this.addIssuerRequest)
        }
      })
    },
    closingIssuerPopup() {
      this.issuerIndex = null
      this.addIssuerRequest = {
        issuer: '',
        document_name_type_id: null,
      }
    },
    documentUpdated(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    documentNotUpdated(message) {
      this.$refs.showLoading = false
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    issuerAdded(data) {
      this.addDocument.issuer_id = data.id
      this.$refs.add_issuer.hide()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    issuerNotAdded(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    checkChanged() {
      this.addDocument.exp_date = null
      this.exp_date = null
      this.addDocument.reminder_id = null
    },
    attahamentFileSelected(obj) {
      const dis = this
      const fileReader = new FileReader()
      fileReader.onload = fileLoadEvent => {
        dis.addDocument.document = fileLoadEvent.target.result
      }
      fileReader.readAsDataURL(obj.target.files[0])
      this.addDocument.url = URL.createObjectURL(obj.target.files[0])
      this.addDocument.file_name = obj.target.files[0].name
    },
    setDocument(document) {
      this.addDocument = document
      this.exp_date = document.exp_date
      LIST.getDocumentIssuersByDocumentNameTypeId(this, this.addDocument.document_name_id)
    },
    setDocumentIssuers(issuers) {
      this.issuers = issuers
    },
    setDocumentReminders(reminders) {
      this.reminders = reminders
    },
    setDocumentVersions(versions) {
      this.versions = versions
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
